var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgRobot = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.5 6.75a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5ZM14 6.75a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5ZM6.5 8.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM11 8.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
  fill: "#D80073"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 1a1 1 0 0 1-.5.866V2.5H12A1.5 1.5 0 0 1 13.5 4v6.5A1.5 1.5 0 0 1 12 12H4a1.5 1.5 0 0 1-1.5-1.5V4A1.5 1.5 0 0 1 4 2.5h3.5v-.634A1 1 0 1 1 9 1ZM4.661 3.5H4a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5h-.662l-1.074 2.686A.5.5 0 0 1 9.8 6.5H6.2a.5.5 0 0 1-.464-.314L4.66 3.5Zm5.6 0-.8 2H6.54l-.8-2h4.522Z",
  fill: "#D80073"
})));

export default SvgRobot;